import { createSelector } from 'reselect';

import { ReduxStickersStore, StickersStoreState } from './typings';

const storeSelector = (storeState: ReduxStickersStore): StickersStoreState => storeState.stickers;

export const getClessonMetaStickers = createSelector(storeSelector, (store) => store.clessonMetaStickers);

export const getClessonStudentsStickers = createSelector(storeSelector, (store) => store.clessonStudentsStickers);

export const getStickerResources = createSelector(storeSelector, (store) => store.stickerResources);

export const getStickerResourcesLoadingStatus = createSelector(
    storeSelector,
    (store) => store.stickerResourcesLoadingStatus
);
